import { Skeleton, Stack } from '@chakra-ui/react';

/**
 * Quiet placeholder for the CONTACT section while the contact is still
 * resolving. Prevents the read-only fields (or the save prompt) from flashing
 * before we know whether the contact has an identity yet.
 */
const ContactDetailsSkeleton: React.FC = () => (
  <Stack gap="2.5">
    <Skeleton height="14px" width="60%" rounded="sm" />
    <Skeleton height="14px" width="80%" rounded="sm" />
  </Stack>
);

export default ContactDetailsSkeleton;
